import { useState } from "react";

import { VariablesContext } from "./context";

const VariablesProvider = ({ children }) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedSensor, setSelectedSensor] = useState(null);
  const [showHeatMap, setShowHeatMap] = useState(false);
  const [showMobility, setShowMobility] = useState(false);
  const [sensorFilters, setSensorFilters] = useState([]);

  const handleSelectedItem = (item) => {
    setSelectedItem(item);
  };

  return (
    <VariablesContext.Provider
      value={{
        getSelectedItem: selectedItem,
        setSelectedItem: handleSelectedItem,
        getSelectedSensor: selectedSensor,
        setSelectedSensor: setSelectedSensor,
        getSensorFilters: sensorFilters,
        setSensorFilters,
        showHeatMap,
        setShowHeatMap,
        showMobility,
        setShowMobility,
      }}
    >
      {children}
    </VariablesContext.Provider>
  );
};

export default VariablesProvider;
